<template>
  <footer>
    <b-container class="py-4">
      <b-row align-h="between">
        <b-col cols="auto" class="mr-auto">
          <impact-logo width="100" class="mb-1" wordfill="ffffff" />
          <p class="text-white"> <small>&copy; {{ new Date().getFullYear() }} {{ company }}.</small></p>
        </b-col>
        <b-col cols="auto" class="text-md-right">
          <div class="h5 mb-1">
            <linked-in width="25px" class="mx-2 my-1" />
            <instagram width="25px" class="mx-2 my-1" />
            <facebook width="12px" class="mx-2 my-1" />
          </div>
          <p class="text-white"><small>1015 West Bobo Newsom Hwy. Hartsville, SC  29550</small></p>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
import ImpactLogo from "@/components/elements/ImpactLogo";
import Facebook from "@/components/elements/facebook";
import Instagram from "@/components/elements/Instagram";
import LinkedIn from "@/components/elements/LinkedIn";

export default {
  name: "footersection",
  components: {LinkedIn, Instagram, Facebook, ImpactLogo},
  inject: ["jumpTo"],
  data() {
    return {
      pages: [
        {
          order: 1,
          section: "services",
          display: "What we do"
        },
        {
          order: 2,
          section: "about",
          display: "Who we are"
        },
        {
          order: 3,
          section: "contact",
          display: "Get in touch"
        }
      ]
    }
  },
  computed: {
    company: function () {
      return process.env.VUE_APP_COMPANY_NAME;
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/custom';

footer {
  border-top: 3px solid $primary;

  p {
    line-height: 1.0;
  }
  .nav-item {
    line-height: 0.75;

    .nav-link {
      color: #ffffff;
      //text-transform: none;
    }
  }
}

</style>